
<ngx-skeleton-loader 
    *ngIf="lendo" 
    [count]="quantidade" 
    [appearance]="aparencia" 
    [animation]="animacao" 
    [theme]="theme">
</ngx-skeleton-loader>
{{lendo ? '' : texto }}